<template>
  <BModal
    :id="id"
    hide-header
    hide-footer
    centered
    content-class="rounded-2xl border-0 p-[.75rem]"
    @shown="onShown"
    @hidden="onClose"
  >
    <!-- Modal Header with Title and Close X Button -->
    <div class="flex items-center justify-between relative mb-[1rem]">
      <h3 class="font-bold text-[18px] md:text-[20px] text-[#333333] text-center w-full mb-0">
        Penggantian Akun
      </h3>
      <button
        type="button"
        class="absolute right-0 top-1/2 -translate-y-1/2 text-[#828282] hover:text-black focus:outline-none p-[.25rem] border-0 bg-transparent cursor-pointer"
        @click="onClose"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line
            x1="18"
            y1="6"
            x2="6"
            y2="18"
          />
          <line
            x1="6"
            y1="6"
            x2="18"
            y2="18"
          />
        </svg>
      </button>
    </div>

    <!-- Form Content with VeeValidate -->
    <ValidationObserver
      ref="formRules"
      #default="{ invalid, handleSubmit }"
    >
      <BForm @submit.prevent="handleSubmit(submitForm)">
        <!-- Nama Akun -->
        <div class="mb-[.75rem]">
          <ValidationProvider
            v-slot="{ errors }"
            name="Nama Akun"
            rules="required"
          >
            <label class="text-[#333333] text-[13px] font-medium mb-[.25rem] block">
              Nama Akun
            </label>
            <BFormInput
              v-model="form.account_name"
              placeholder="Marketing01"
              class="w-full !rounded-lg !p-[0.625rem_0.75rem] border-[#E2E2E2]"
              :class="{ 'is-invalid': errors.length > 0 }"
            />
            <span
              v-if="errors.length > 0"
              class="text-danger text-sm mt-[.25rem] block"
            >
              {{ errors[0] }}
            </span>
          </ValidationProvider>
        </div>

        <!-- ID Business Manager -->
        <div class="mb-[.75rem]">
          <ValidationProvider
            v-slot="{ errors }"
            rules="required|numeric"
            name="ID Business Manager"
          >
            <label class="text-[#333333] text-[13px] font-medium mb-[.25rem] block">
              ID Business Manager
            </label>
            <BFormInput
              v-model="form.bm_id"
              placeholder="083475834920300"
              class="w-full !rounded-lg !p-[0.625rem_0.75rem] border-[#E2E2E2]"
              :class="{ 'is-invalid': errors.length > 0 }"
            />
            <span
              v-if="errors.length > 0"
              class="text-danger text-sm mt-[.25rem] block"
            >
              {{ errors[0] }}
            </span>
          </ValidationProvider>
        </div>

        <!-- ID Ad Account -->
        <div class="mb-[.75rem]">
          <ValidationProvider
            v-slot="{ errors }"
            rules="required|numeric"
            name="ID Ad Account"
          >
            <label class="text-[#333333] text-[13px] font-medium mb-[.25rem] block">
              ID Ad Account
            </label>
            <BFormInput
              v-model="form.ad_account_id"
              placeholder="0987656789304594832"
              class="w-full !rounded-lg !p-[0.625rem_0.75rem] border-[#E2E2E2]"
              :class="{ 'is-invalid': errors.length > 0 }"
            />
            <span
              v-if="errors.length > 0"
              class="text-danger text-sm mt-[.25rem] block"
            >
              {{ errors[0] }}
            </span>
          </ValidationProvider>
        </div>

        <!-- Business Manager Komerce -->
        <div class="mb-[.75rem]">
          <ValidationProvider
            v-slot="{ errors }"
            name="Business Manager Komerce"
            rules="required"
          >
            <label class="text-[#333333] text-[13px] font-medium mb-[.25rem] block">
              Business Manager Komerce
            </label>
            <BFormSelect
              v-model="form.system_bm_id"
              :options="systemBmOptions"
              value-field="id"
              text-field="bm_name"
              class="w-full !rounded-lg border-[#E2E2E2]"
              :class="[
                { '!text-[#828282]': !form.system_bm_id, '!text-[#333333]': Boolean(form.system_bm_id) },
                errors.length > 0 ? 'is-invalid' : ''
              ]"
            >
              <template #first>
                <b-form-select-option
                  value=""
                  disabled
                  class="text-[#828282]"
                >
                  Pilih Business Manager
                </b-form-select-option>
              </template>
            </BFormSelect>
            <span
              v-if="errors.length > 0"
              class="text-danger text-sm mt-[.25rem] block"
            >
              {{ errors[0] }}
            </span>
          </ValidationProvider>
        </div>

        <!-- Catatan Perubahan (Opsional) -->
        <div class="mb-[1rem]">
          <label class="text-[#333333] text-[13px] font-medium mb-[.25rem] block">
            Catatan Perubahan (Opsional)
          </label>
          <BFormTextarea
            v-model="form.resolution_notes"
            placeholder="Tambahkan catatan"
            rows="4"
            class="w-full !rounded-lg !p-[0.625rem_0.75rem] border-[#E2E2E2]"
          />
        </div>

        <!-- Buttons -->
        <div class="flex flex-row gap-[1rem]">
          <BButton
            variant="outline-primary"
            class="w-full !rounded-lg !border-[#F95031] !text-[#F95031] hover:!bg-[#F95031] hover:!text-white font-semibold py-[0.625rem]"
            @click="onClose"
          >
            Batal
          </BButton>
          <BButton
            type="submit"
            variant="primary"
            class="w-full !rounded-lg bg-[#F95031] text-white font-semibold py-[0.625rem]"
            :disabled="invalid || Object.values(mandatoryFinalForm).length < 1"
          >
            Simpan
          </BButton>
        </div>
      </BForm>
    </ValidationObserver>
  </BModal>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required, numeric } from '@validations'

export default {
  name: 'ModalChangeAccount',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    id: {
      type: String,
      default: 'modal-change-account',
    },
    detail: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      required,
      numeric,
      form: {
        account_name: '',
        bm_id: '',
        ad_account_id: '',
        system_bm_id: '',
        resolution_notes: '',
      },
      systemBmOptions: [],
    }
  },
  computed: {
    matchedBm() {
      return this.systemBmOptions.find(
        item => item.bm_name === this.detail.business_manager,
      )
    },
    mandatoryFinalForm() {
      const mandatoryFinalForm = {}
      if (this.form.account_name && this.form.account_name !== this.detail.account_name) mandatoryFinalForm.account_name = this.form.account_name
      if (this.form.bm_id && this.form.bm_id !== this.detail.bm_id) mandatoryFinalForm.bm_id = this.form.bm_id
      if (this.form.ad_account_id && this.form.ad_account_id !== this.detail.ad_account_id) mandatoryFinalForm.ad_account_id = this.form.ad_account_id
      if (this.form.system_bm_id && this.form.system_bm_id !== this.matchedBm.id) mandatoryFinalForm.system_bm_id = this.form.system_bm_id

      return mandatoryFinalForm
    },
  },
  methods: {
    async onShown() {
      await this.loadSystemBusinessManagerList()
      if (this.$refs.formRules) {
        this.$refs.formRules.reset()
      }

      this.form = {
        account_name: this.detail.account_name || '',
        bm_id: this.detail.bm_id || '',
        ad_account_id: this.detail.ad_account_id || '',
        system_bm_id: this.matchedBm.id || '',
        resolution_notes: '',
      }

      this.$nextTick(() => {
        if (this.$refs.formRules) {
          this.$refs.formRules.reset()
        }
      })
    },
    onClose() {
      this.$emit('close')
      this.form = {
        account_name: '',
        bm_id: '',
        ad_account_id: '',
        system_bm_id: '',
        resolution_notes: '',
      }
    },
    async loadSystemBusinessManagerList() {
      try {
        const {
          data: { data },
        } = await newAxiosIns.get('komads/api/v1/admin/system_bm/list')

        if (Array.isArray(data) && data.length > 0) {
          this.systemBmOptions = data
        }
      } catch {
        this.systemBmOptions = []
      }
    },
    submitForm() {
      const finalForm = { ...this.mandatoryFinalForm }
      if (this.form.resolution_notes) finalForm.resolution_notes = this.form.resolution_notes
      this.$emit('submit', finalForm)
    },
  },
}
</script>
